module.exports = __webpack_public_path__ + "mo/img/brand03.f455ffa0.png";